import { defineMessages } from 'react-intl';

import { ReadWriteType, StateEntryProps } from '.';

defineMessages({
  placeholderText: {
    id: 'builder.nodes.multipleInput.state.placeholderTexts',
    defaultMessage: 'Schreib hier… ',
  },
  buttonText: {
    id: 'builder.nodes.multipleInput.state.buttonText',
    defaultMessage: 'Weiter',
  },
});

// single Multiple Input - without message / without template
// same like multipleInputStateEntry, but without message
export const multipleInputSingleStateEntry: StateEntryProps = {
  version: 'v1',
  type: 'renderMultipleInputSingle',
  temporary: true,
  payload: {
    placeholderTexts: ['builder.nodes.multipleInput.state.placeholderTexts'],
    buttonText: 'builder.nodes.multipleInput.state.buttonText',
    saveResultTo: 'snippets',
    getValueFrom: '',
    minItems: 1,
    maxItems: 10,
  },
  saveResultType: ReadWriteType.stringArray,
  getValueType: ReadWriteType.stringArray,
  displayName: 'Multiple Input',
  nodeType: 'multipleInputSingleStateEntry',
  handleOutCount: 1,
};
